import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useGeolocationStore = defineStore('geolocation', {
  state,
  getters,
  actions
})

export default useGeolocationStore
